import { log } from "./log";
import { client } from "./supabase";

// `radar_borradores` (Fase B, ESCRITA SIN APLICAR — 10.137, migración
// 20260926b_radar_borradores.sql): trazabilidad de "abrió el borrador de mail y no lo mandó".
// Abrir el borrador NUNCA cambia el estado de la alerta (`escrita` solo llega por
// `radarMailSaliente.js`, cuando gmail-sync confirma el envío real) — este insert es puramente
// informativo para la página de gestión de una fase futura.
//
// Nunca bloquea: si la tabla no existe todavía o el insert falla por cualquier motivo, se loguea
// (10.170) y se resuelve igual — "Abrir en Gmail" abre la pestaña pase lo que pase acá.
export const registrarBorradorRadar = async ({ pais, empresaNorm, mes, ano, lado, clientId, usuarioId }) => {
  try {
    const { error } = await client.from("radar_borradores").insert({
      pais,
      empresa_norm: empresaNorm,
      mes,
      ano,
      lado,
      client_id: clientId,
      abierto_por: usuarioId,
    });
    if (error) log.error("registrarBorradorRadar", error);
  } catch (error) {
    log.error("registrarBorradorRadar", error);
  }
};
